let inited = false;
export const features = {
  iOS: false,
  android: false,
  winMobile: false,
  mobile: false,
  safari: false, // now just for desktop safari hacks
};

// -------------------------------------------------------
// Init
// -------------------------------------------------------

export const init = () => {
  if (!inited) {
    inited = true;
    features.iOS = /iPad|iPhone|iPod/.test(navigator.platform);
    features.android =
      navigator.userAgent.toLowerCase().indexOf('android') > -1;
    if (
      navigator.userAgent.match(/Windows Phone/i) ||
      navigator.userAgent.match(/iemobile/i) ||
      navigator.userAgent.match(/WPDesktop/i)
    ) {
      features.winMobile = true;
    }

    if (features.android || features.iOS || features.winMobile) {
      features.mobile = true;
    }

    if (
      !features.mobile &&
      navigator.userAgent.toLowerCase().indexOf('safari') !== -1 &&
      navigator.userAgent.toLowerCase().indexOf('chrome') === -1
    ) {
      features.safari = true;
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/Features.js